module.exports = __webpack_public_path__ + "img/add.d3c652aa.svg";